
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AboutPage from "../pages/about/page";
import EpisodesPage from "../pages/episodes/page";
import MorePage from "../pages/more/page";
import StorePage from "../pages/store/page";
import CollectivePage from "../pages/collective/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/episodes",
    element: <EpisodesPage />,
  },
  {
    path: "/more",
    element: <MorePage />,
  },
  {
    path: "/store",
    element: <StorePage />,
  },
  {
    path: "/collective",
    element: <CollectivePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
